/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * Apply For Benefits Messages
 *
 * This contains all the text for the Apply For Benefits component.
 * 
 * SD-1067
 * This file is customized as part the component but no changes made
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  applyForBenefitsPageAriaLabel: {
    id: 'ApplyForBenefits_AriaLabel',
    defaultMessage: 'apply-for-benefits',
  },
  applyForBenefitsPageTitle: {
    id: 'ApplyForBenefits_PageTitle',
    defaultMessage: 'Apply for Benefits',
  },
  applyForBenefitsApplyButton: {
    id: 'ApplyForBenefits_ApplyButton',
    defaultMessage: 'Apply',
  },
  applyForBenefitsApplyDetailsButtonAriaLabel: {
    id: 'ApplyForBenefits_ApplyDetailsButtonAriaLabel',
    defaultMessage: 'Apply for {name} application',
  },
  applyForBenefitsLearnMoreHyperlink: {
    id: 'ApplyForBenefits_LearnMoreHyperlink',
    defaultMessage: 'Learn more',
  },
  applyForBenefitsDownloadApplicationHyperlink: {
    id: 'ApplyForBenefits_DownloadApplicationHyperlink',
    defaultMessage: 'Download application',
  },

  //SD-7063 - ak - update verbiage
  applyForBenefitsYourBenefitsHyperlink: {
    id: 'ApplyForBenefits_YourBenefitsHyperlink',
    defaultMessage: 'Back',
  },
  checkBenefitsHyperlink: {
    id: 'ApplyForBenefits_CheckBenefitsHyperlink',
    defaultMessage: 'check do I qualify',
  },
  checkBenefitsHyperlinkPartOne: {
    id: 'ApplyForBenefits_CheckBenefitsHyperlinkPartOne',
    defaultMessage: 'Or first {link}',
  },
  applyForBenefitsResumeDialogTitle: {
    id: 'ApplyForBenefits_ResumeDialogTitle',
    defaultMessage: 'Application in progress',
  },
  applyForBenefitsResumeDialogDescription: {
    id: 'ApplyForBenefits_ResumeDialogDescription',
    defaultMessage: 'Beginning of dialog window. Escape will cancel and close the window.',
  },
  applyForBenefitsResumeButton: {
    id: 'ApplyForBenefits_ResumeButton',
    defaultMessage: 'Resume',
  },
  applyForBenefitsCancelButton: {
    id: 'ApplyForBenefits_CancelButton',
    defaultMessage: 'Cancel',
  },
  applyForBenefitsStartAgainHyperlink: {
    id: 'ApplyForBenefits_StartAgainHyperlink',
    defaultMessage: 'start again',
  },
  applyForBenefitsResumeDialogContent: {
    id: 'ApplyForBenefits_ResumeDialogContent',
    defaultMessage:
      'Your {appname} is currently in progress. This was last updated on {lastupdate}.',
  },
  applyForBenefitsResumeDialogContentResume: {
    id: 'ApplyForBenefits_ResumeDialogContentResume',
    defaultMessage: 'Would you like to resume your previously saved application or {link}?',
  },
  applyForBenefitsRentAriaLabel: {
    id: 'ApplyForBenefits_RentAriaLabel',
    defaultMessage: 'rent',
  },
  icon: {
    id: 'Icon',
    defaultMessage: 'Icon of application',
  },
  programIcon: {
    id: 'Program_Icon',
    defaultMessage: 'Icon of program',
  },
});
